
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { PoolTeamModel } from './Entities.GormCrm.PoolTeam';
import { QueryModel } from './Entities.GormCrm.Query';
import { Model, ModelProperty } from 'models/Model';


export class PoolModel extends Model<PoolModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'pool.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'pool.property.name' },
		{ name: 'data', type: 'string', languageString: 'pool.property.data' },
		{ name: 'icon', type: 'string', languageString: 'pool.property.icon' },
		{ name: 'queryId', type: 'guid', languageString: 'pool.property.queryId' },
		{ name: 'created', type: 'Date', languageString: 'pool.property.created', isHidden: true },
		{ name: 'poolTeams', type: 'PoolTeamModel[]', languageString: 'pool.property.poolTeams', isHidden: true, isArray: true, isObject: true, new: () => { return new PoolTeamModel }, properties: () => { return PoolTeamModel.classProperties } },
		{ name: 'query', type: 'QueryModel', languageString: 'pool.property.query', isHidden: true, isObject: true, new: () => { return new QueryModel }, properties: () => { return QueryModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public data: string;
	public icon: string;
	public queryId?: string;
	public created?: Date;
	public poolTeams: PoolTeamModel[];
	public query?: QueryModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.data = '';
		this.icon = '';
		this.queryId = undefined;
		this.created = undefined;
		this.poolTeams = [];
		this.query = undefined;
		
	}
	getProperties(){
		return PoolModel.classProperties;
	}
}

